import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Button,
  Grid,
  Box
} from '@mui/material';
import uploadImg from '../img/upload-cv.png';

const Home = () => {
  const navigate = useNavigate();

  const goToParsing = () => {
    navigate('/ajouter-cv');
  };

  return (
    <Container >
      {/* Section de présentation */}
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={6}>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            🚀 Parsing de CV intelligent
          </Typography>
          <Typography variant="body1" color="text.secondary" mb={3}>
            Automatisez l’analyse, la correction et la génération de CV anonymisés avec notre moteur IA.
          </Typography>
          <Button
            variant="contained"
            onClick={goToParsing}
            sx={{ textTransform: 'none', px: 4 }}
          >
            Démarrer
          </Button>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            component="img"
            src={uploadImg}
            alt="Upload CV"
            sx={{ width: '100%', maxHeight: 280, objectFit: 'contain' }}
          />
        </Grid>
      </Grid>

      {/* Étapes */}
      <Box mt={8}>
        <Typography variant="h5" fontWeight="bold" textAlign="center" gutterBottom color="primary">
          Comment ça fonctionne ?
        </Typography>
        <Grid container spacing={3} mt={1}>
          {[
            {
              title: '1. Ajout du CV',
              desc: 'Déposez un fichier Word ou PDF contenant un CV.'
            },
            {
              title: '2. Extraction & Correction',
              desc: 'Corrigez les données extraites automatiquement par l’IA.'
            },
            {
              title: '3. Génération anonymisée',
              desc: 'Générez une version propre et anonymisée prête à être envoyée.'
            }
          ].map((step, i) => (
            <Grid item xs={12} md={4} key={i}>
              <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 2, p: 2 }}>
                <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                  {step.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {step.desc}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default Home;
